import React, { memo, useCallback, useState } from "react";
import Confirm from "../../confirm/Confirm";
import WorkflowHeader from "../components/WorkflowHeader";

interface WorkflowModalProviderProps {
    children: React.ReactNode;
    title?: string;
    onHide?: () => void;
}

function WorkflowModalProvider({ children, title, onHide }: WorkflowModalProviderProps) {
    const [isModalInitialized, setIsModalInitialized] = useState(false);

    const onHideModal = useCallback(() => {
        onHide?.();
    }, [onHide]);

    return (
        <Confirm
            shouldShow
            size="xl"
            fullscreen="true"
            dialogClassName="full-size-container"
            keyboardContext="workflow"
            onHide={onHideModal}
            shouldShowFooter={false}
            closeText="Close"
            title={<WorkflowHeader title={title} />}
            bodyClassName="p-0"
            onEntered={() => {
                setIsModalInitialized(true);
            }}
        >
            {isModalInitialized && children}
        </Confirm>
    );
}

WorkflowModalProvider.defaultProps = {
    onHide: undefined,
    title: undefined,
};

export default memo(WorkflowModalProvider);
